module.exports = __webpack_public_path__ + "img/alert.a69a2bbd.png";